<script setup lang="ts">
  import { ISearchCmsData } from "@/view-models/search.model"

  defineProps<{
    placeholder: string
    cmsData: ISearchCmsData
  }>()

  const query = defineModel<string>("query", { required: true })

  const emit = defineEmits<{
    (e: "update:query", value: string): void
    (e: "execute-search"): void
    (e: "clear-query"): void
  }>()

  const executeSearchDebounced = useDebounceFn(() => {
    emit("execute-search")
  }, 500)

  watch(
    () => query.value,
    () => {
      executeSearchDebounced()
    }
  )
</script>

<template>
  <div class="relative flex w-full mx-auto mb-8 md:max-w-2.5xl-plus">
    <input
      v-model="query"
      class="w-full rounded-full pl-11 bg-sg-700 ring-2 label--xs text-wg-200 caret-wg-300 focus-visible:ring-2 focus-visible:ring-wg-300 focus-visible:outline-wg-300 focus-visible:outline-offset-4 placeholder:text-label-sm ring-wg-400 px-6 placeholder:text-wg-200 placeholder:font-normal flex-grow"
      type="text"
      :placeholder="cmsData.searchbarPlaceholder"
      autocomplete="off"
    />
    <button
      v-if="!query.length"
      class="absolute left-3 top-1/2 -translate-y-1/2 h-6"
      alt="Klik hier om te zoeken"
      @click="$emit('execute-search')"
    >
      <svg
        class="icon icon-search fill-wg-300 h-6 w-6 ml-0"
        role="presentation"
      >
        <use xlink:href="#icon-search" />
      </svg>
    </button>
    <button
      v-else
      class="absolute left-3 top-1/2 -translate-y-1/2 h-6"
      alt="Klik hier om je zoekterm te verwijderen"
      @click="$emit('clear-query')"
    >
      <svg
        class="icon icon-x fill-wg-300 h-6 w-6 ml-0"
        role="presentation"
      >
        <use xlink:href="#icon-x" />
      </svg>
    </button>
  </div>
</template>
